module.exports = __webpack_public_path__ + "static/media/producitivity-help.1e6e80e0.jpg";